import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic11 from '../assets/images/ahbgroup.jpg'
import values from '../assets/images/values.jpg'


const Generic = (props) => (
    <div>
        <Helmet>
            <title>Valores</title>
            <meta name="description" content="AH Business Group" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h8>Os nossos valores</h8>
                    </header>
                    <span className="image main"><img src={values} alt="" /></span>
                    <p> Assumindo um elevado compromisso com as Pessoas, e fortemente alicerçada na <b>transparência</b> das 
                    suas relações internas e externas, a Gestão de Pessoas da AHB valoriza, fruto do empreendedorismo 
                    que está na origem deste grupo empresarial, o espírito de iniciativa e a <b>confiança</b> nas capacidades de gestão.</p> 

                    <p> Com o foco no desenvolvimento individual de competências orientado para a 
                    pretendida progressão na carreira, e por acreditar que em cada colaborador existe
                     um potencial capaz de se traduzir em renovadas competências, privilegia o recrutamento interno e 
                     apoia a evolução pessoal e profissional de cada colaborador.</p> 

                    <p> Por considerar que os seus recursos humanos representam a primordial e mais importante energia das 
                    suas empresas, promove e apoia o seu crescimento dentro da organização alinhando objetivos institucionais 
                    e pessoais numa sinergia de elevado valor acrescentado só possível com uma gestão integrada e crente na 
                    motivação como ponto de partida para os consequentes resultados.</p> 

                    <p> Acreditando na <b>competitividade</b> no curto e médio prazos, assente no profissionalismo e rigor dos seus colaboradores,
                    e da vontade de estes se superarem a cada dia, a AHB continuará a apostar na excelência das suas Pessoas na sua busca 
                    por mais e melhores resultados.</p> 
                </div>
            </section>
        </div>

    </div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/values.js